export default __webpack_public_path__ + "static/as_built-93172c0d58d57ae68faaee1e239a23dd.jpg";